/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import FlexTableRow from '@/components/FlexTableRow';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';
import WideTableCell from '@/components/WideTableCell';
import { airlineMapping } from '@/pages/vcms/vex/vn/ve-may-bay/[slug]';
import { useLazyGetFlightStatisticsSeoRouteQuery } from '@/slices/flightData/apis/flightDataApi';
import { style } from '@/styles/globals';
import { convertMoney } from '@/utils/convertMoney';
import { useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { styled } from '@mui/system';
import { ReserveButton } from './ReserveButton';

const StyledPriceText = styled('div')`
  font-weight: bold;
  width: 100%;
  padding: 0px 10px;
`;

export default function FareInDayNewYearVcms({
  days,
  onSelectTrip,
  lang,
}: any) {
  // console.log('days', days);
  const TableHeader = [
    lang?.TetHolidayPriceTable?.lunarTitle || 'Ngày Tết (âm lịch)',
    lang?.TetHolidayPriceTable?.lunarCheapestPrice || 'Giá vé Tết<br/>rẻ nhất',
    lang?.TetHolidayPriceTable?.airline || 'Hãng bay',
  ];

  const tetDaysObjs = days;

  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{}}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow
            sx={{
              background: 'white',
              border: 0,
              display: 'flex',
            }}
          >
            {TableHeader.map((label: any, i: number) => {
              if (label) {
                // label = (!isDesktop && i === 2) ? '' : label;
                return (
                  <WideTableCell
                    key={label}
                    sx={{
                      ...(i === 0 ? { whiteSpace: 'nowrap' } : {}),
                    }}
                    align="center"
                  >
                    <div dangerouslySetInnerHTML={{ __html: label }} />
                  </WideTableCell>
                );
              }
            })}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {tetDaysObjs.length > 0 ? (
            (tetDaysObjs || []).map((row: any, i: number) => (
              <FlexTableRow
                key={i.toString()}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  display: 'flex',
                }}
              >
                <WideTableCell align="center">
                  <div>{`${row?.dayVN}/${row?.monthVN}`}</div>
                  <div>{row?.pickup_time}</div>
                </WideTableCell>
                <WideTableCell
                  sx={{
                    fontWeight: '500',
                    color: style.primary.blue,
                  }}
                  align="center"
                >
                  {row?.averageMinfare ? convertMoney(row?.averageMinfare).replace('đ', (lang?.global?.VND || 'đ')) : (lang?.global.updating || 'Đang cập nhật')}
                </WideTableCell>
                <WideTableCell align="center">
                  {row?.airline?.name ? (
                    <StyledPriceText>
                      {row?.airline?.name}
                    </StyledPriceText>
                  ) : (
                    <StyledPriceText>
                      {lang?.global.updating || 'Đang cập nhật'}
                    </StyledPriceText>
                  )}
                  {row?.airline?.name && (
                  <ReserveButton
                    onClick={() => onSelectTrip(row)}
                    lang={lang}
                  />
                  )}
                </WideTableCell>
              </FlexTableRow>
            ))
          ) : (
            <Box sx={{ p: pr`16px` }}>
              <ShowNoDataDescription lang={lang} />
            </Box>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
